import { useTranslation } from 'react-i18next';

import { Alert } from '@/components/atoms/Alert';
import { ApiErrorMessage } from '@/components/atoms/ApiErrorMessage';
import { Spinner } from '@/components/atoms/Spinner';

import { PublicVideoLayout } from '../PublicVideoLayout';

import LoginEmailStep from './components/LoginEmailStep';
import LoginPasswordStep from './components/LoginPasswordStep';
import LoginProviderStep from './components/LoginProviderStep';
import { useLoginFlow } from './useLoginFlow';

import styles from './Login.module.scss';

export function Login() {
    const {
        step,
        setStep,
        values,
        setValues,
        authOptions,
        checkingEmail,
        emailError,
        setEmailError,
        loading,
        loginError,
        handleEmailSubmit,
        handleProviderLogin,
        handlePasswordLogin,
    } = useLoginFlow();
    const { t } = useTranslation();

    return (
        <PublicVideoLayout>
            <h2>{t('publicPages.login.helloAgain')}</h2>
            <h3>{t('publicPages.login.signInToYourAccount')}</h3>
            {step === 'checkingCache' && (
                <div className={styles.cacheCheck}>
                    <Spinner size="lg" fullScreen className={styles.loader} />
                </div>
            )}
            {step === 'email' && (
                <LoginEmailStep
                    values={values}
                    setValues={setValues}
                    emailError={emailError}
                    setEmailError={setEmailError}
                    checkingEmail={checkingEmail}
                    onSubmit={handleEmailSubmit}
                />
            )}
            {step === 'provider' && (
                <LoginProviderStep
                    authOptions={authOptions}
                    onProviderLogin={handleProviderLogin}
                    onUseDifferentEmail={() => setStep('email')}
                />
            )}
            {step === 'password' && (
                <LoginPasswordStep
                    values={values}
                    setValues={setValues}
                    loading={loading}
                    onSubmit={handlePasswordLogin}
                    onUseDifferentEmail={() => setStep('email')}
                />
            )}

            {step !== 'email' && loginError ? (
                <Alert tone="danger" className={styles.message}>
                    <ApiErrorMessage error={loginError} />
                </Alert>
            ) : (
                ''
            )}
        </PublicVideoLayout>
    );
}
